export const USER = 'USER';
export const MANAGE = 'MANAGE';
export const ORDER = 'ORDER';
export const REPORT = 'REPORT';
export const SETTING = 'SETTING';
export const CHAT = 'CHAT'
export const CHAT_SUMMARY = 'CHAT_SUMMARY'
